import { InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import React, { Fragment, JSX } from 'react';
import { FormInputNameClient } from '../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
  onCheckCPF: (cpf: string) => void;
}

type Props = StateProps & DispatchProps;

export const PersonalDataContent: React.FC<Props> = ({
  formData,
  onChangeFormInput,
  onCheckCPF,
  formErrors,
}): JSX.Element => (
  <Fragment>
    <h2 className="font-dmsans font-normal text-neutro-b-400 text-[28px]">Informações pessoais</h2>
    <p className="font-dmsans text-base font-normal text-neutro-w-600 leading-[28px]">
      Preencha seus dados
    </p>
    <div className="md:w-[500px] mt-[20px]">
      <form onSubmit={e => e.preventDefault()}>
        <div className="mb-[20px]" id="divCPF">
          <InputText
            name="cpf"
            label="CPF"
            placeholder="123.456.789-00"
            className={`appearance-none w-full
                    rounded-md text-heading leading-tight focus:outline-none
                    focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputNameClient.cpf]}
            onChange={e => onChangeFormInput(FormInputNameClient.cpf)(e.target.value)}
            onBlur={e => onCheckCPF(e.target.value)}
            error={formErrors.cpf && formErrors.cpf[0]}
          />
        </div>
        <div className="mb-[20px]">
          <InputText
            name="email"
            label="E-mail"
            placeholder="meuemail@email.com"
            className={`appearance-none w-full
                    rounded-md text-heading leading-tight focus:outline-none
                    focus:shadow-outline text-xs font-dmsans font-normal`}
            value={formData[FormInputNameClient.email]}
            onChange={e => onChangeFormInput(FormInputNameClient.email)(e.target.value)}
            error={formErrors.email && formErrors.email[0]}
          />
        </div>
        <div className="mb-[20px]">
          <InputText
            name="phone"
            label="Telefone"
            placeholder="(00) 0 0000-0000"
            className={`appearance-none w-full
                    rounded-md text-heading leading-tight focus:outline-none
                    focus:shadow-outline text-xs font-dmsans font-normal`}
            value={formData[FormInputNameClient.phone]}
            onChange={e => onChangeFormInput(FormInputNameClient.phone)(e.target.value)}
            error={formErrors.phone && formErrors.phone[0]}
          />
        </div>
      </form>
    </div>
  </Fragment>
);
